var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00005 7.05623L10.225 11.2813C10.5167 11.5729 10.9896 11.5729 11.2813 11.2813C11.5729 10.9895 11.5729 10.5167 11.2813 10.2249L7.05629 6L11.2813 1.77501C11.5729 1.48334 11.5729 1.01044 11.2813 0.718768C10.9896 0.42709 10.5167 0.42709 10.225 0.718768L6.00005 4.94376L1.775 0.718754C1.48333 0.427082 1.01043 0.427082 0.718754 0.718754C0.427082 1.01043 0.427082 1.48333 0.718754 1.77501L4.94373 6L0.718754 10.225C0.427082 10.5167 0.427082 10.9895 0.718754 11.2813C1.01043 11.5729 1.48333 11.5729 1.775 11.2813L6.00005 7.05623Z",
    fill: "#21272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ec62c4678419b2b0d1a0a1045d689ace.svg";
export { ForwardRef as ReactComponent };